export const version="0.1.1"
export const build = 60

export const project = {
    "dev":"Narravero DEV",
    "test":"Narravero TEST",
    "prod":"Narravero"
}
